<script setup lang="ts">
import type { Option } from '@autobid/strapi-integration/typescript/webapi/Dictionary'
import { useFormGroupItem } from '@autobid/nuxt-pinia-store/store/searchStore/useFormGroupItem'
import CheckboxLabel from '@autobid/ui/components/elements/checkbox/CheckboxLabel.vue'
import { Switch } from '@headlessui/vue'

interface Props {
  option: Option
  color?: string
  groupKey: string
}

const props = defineProps<Props>()

function getIconText(label: string) {
  return label.split(' ')[1].split('').slice(0, 2).join('')
}

const selected = useFormGroupItem(props.groupKey, props.option.id)
</script>

<template>
  <Switch
    v-model="selected"
    class="relative col-span-6 flex items-center gap-4 rounded-full @md:col-span-3 @xl:col-span-2"
  >
    <div
      class="flex h-11 w-11 min-w-[2.75rem] items-center justify-center rounded-full border-2 border-primary p-4 transition hover:scale-110"
      :class="selected ? 'bg-primary' : 'bg-white'"
    >
      <span class="text-xl" :class="selected ? 'text-white' : 'text-primary'">{{
        getIconText(option.label)
      }}</span>
    </div>
    <CheckboxLabel
      :label-props="{
        class: 'text-ellipsis overflow-hidden',
        title: option.label,
      }"
    >
      {{ option.label }}
    </CheckboxLabel>
  </Switch>
</template>
